<div>
  <mat-tab-group [ngClass]="orientation">
    <mat-tab>
      <ng-template mat-tab-label>
        <span
          [ngClass]="{
            invalid: !readOnly() && contractForm?.isValid === false,
            dirty: !readOnly() && contractForm?.isDirty === true,
          }"
          >Contrat</span
        >
      </ng-template>
      <app-contract-form
        [initWith]="initialContract"
        [employeeId]="initialContact.id"
        [lastSalaryScaleContractUpdate]="lastSalaryScaleContractUpdate"
        [validation]="validation()"
        [readOnly]="readOnly()"
        (previousContractSelected)="onPreviousContractSelected($event)"
      ></app-contract-form>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span
          [ngClass]="{
            invalid: !readOnly() && documentsForm?.form?.valid === false,
            dirty: !readOnly() && documentsForm?.form?.dirty === true,
          }"
          >Documents</span
        >
      </ng-template>
      <app-documents-form
        [companyCar]="contractSig?.()?.companyCar ?? false"
        [initWith]="initialDocuments"
        [readOnly]="readOnly()"
        [validation]="validation()"
        (uploaded)="documentUploaded.emit($event)"
        (metadataChange)="documentsMetadataChanged.emit($event)"
      ></app-documents-form>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span
          [ngClass]="{
            invalid: !readOnly() && employeeForm?.isValid === false,
            dirty: !readOnly() && employeeForm?.isDirty === true,
          }"
          >Employé</span
        >
      </ng-template>
      <app-employee-form
        [initWith]="initialContact"
        [validation]="validation()"
        [readOnly]="readOnly()"
      ></app-employee-form>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <span
          [ngClass]="{
            invalid: !readOnly() && schedulesForm?.isValid === false,
            dirty: !readOnly() && schedulesForm?.isDirty === true,
          }"
          >Horaires</span
        >
        @if (schedulesChanged()) {
          <span class="change-dot" aria-label="contient des modifications"></span>
        }
      </ng-template>
      <app-schedules-form
        [initWith]="initialSchedules"
        [companyId]="contractSig ? contractSig().companyId : undefined"
        [readOnly]="readOnly()"
        [validation]="validation()"
        [previous]="previousSchedules()"
      ></app-schedules-form>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span
          [ngClass]="{
            invalid: !readOnly() && assignmentForm?.form?.valid === false,
            dirty: !readOnly() && assignmentForm?.form?.dirty === true,
          }"
          >Affectations</span
        >
        @if (assignmentChanged()) {
          <span class="change-dot" aria-label="contient des modifications"></span>
        }
      </ng-template>
      <app-assignment-form
        [initWith]="initialAssignment"
        [validation]="validation()"
        [readOnly]="readOnly()"
        [previous]="previousAssignment()"
      ></app-assignment-form>
    </mat-tab>
    @if (initWith(); as contract) {
      @if (showAmendments() && contract.id) {
        <mat-tab>
          <ng-template mat-tab-label>
            <span data-tour-anchor="contract.amendments-tab">Avenants</span>
          </ng-template>
          <app-contract-amendments [contract]="contract"></app-contract-amendments>
        </mat-tab>
      }
    }
  </mat-tab-group>
</div>
